import { Compliance } from '../../../../types'
import { Box, Stack } from '@mui/material'
import ComplianceAlertBox from '../../../../components/ComplianceAlertBox'
import ComplianceAlertMessage from '../../../../components/ComplianceAlertMessage'
import ComplianceDonut from '../../../../components/ComplianceDonut'
import { useMemo } from 'react'

const ComplianceContainer = (props: { waterlineCompliance?: Compliance }) => {
  const { waterlineCompliance } = props

  const complianceValues = useMemo(() => {
    const values = []

    if (waterlineCompliance) {
      values.push(
        {
          compliance: {
            status: waterlineCompliance.compliance_status
          }
        }
      )
    }

    return values
  }, [waterlineCompliance])

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" paddingY={2}>
      <Box data-testid="programs-donut-box">
        <ComplianceDonut
          image="chart-waterline"
          label="Waterline Management"
          values={complianceValues}
          inactiveLabel="Unassigned"
        />
      </Box>
      <Stack direction="row" alignItems="flex-start">
        <Stack>
          <Stack direction="row" spacing={1}>
            <ComplianceAlertBox
              compliance_status={waterlineCompliance?.compliance_status ?? 4}
            />
            <ComplianceAlertMessage
              message={waterlineCompliance?.message_long ?? ''}
              compliance_status={waterlineCompliance?.compliance_status ?? 4}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ComplianceContainer